/**
 * @module app.cm
 */

import { isNullOrUndefined } from 'app/shared/lib/utilities';
import * as CM from 'app/cm/models/essette-api';

export function caseIsReadOnly($case: CM.Case, userId: string): boolean {
    return $case.isClosed ?? true;
}

export type CaseServiceDefaults = {
    serviceCode: string,
    placeOfServiceCode?: string,
    modifierCode?: string
}
/**
 * Parses the default values from a CM Case Service Task Description
 * @param description
 */
export function parseCaseServiceDefaults(description: string): CaseServiceDefaults {
    const defaultValues: string[] | undefined = description.match('\\[(?<match>.*?)\\]')?.groups?.match?.split(',');
    let serviceCode: string = '';
    let modifierCode: string | undefined;
    let placeOfServiceCode: string | undefined;

    if(defaultValues) {
        const defaultsLength: number = defaultValues.length;

        if(defaultsLength > 0 && defaultValues[0]) {
            serviceCode = defaultValues[0].trim();
        }
        if(defaultsLength > 1 && defaultValues[1]) {
            placeOfServiceCode = defaultValues[1].trim();
        }
        if(defaultsLength > 2 && defaultValues[2]) {
            modifierCode = defaultValues[2].trim();
        }
    }

    return { serviceCode, placeOfServiceCode, modifierCode };
}
